module.exports = __webpack_public_path__ + "images/file_icons_v2/dwg-144be359d4592f239052821d39d7be84.svg";